import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import MessageList from '../MessageList'
import MessageInput from '../MessageInput'
import SelectReceivers from '../SelectReceivers'
import SelectCategories from '../SelectCategories'
import { Input, Button } from 'antd'

import './MessageBoxContent.scss'

function GeneralMessageOptions ({ generalMessageOptions, chat, onCategoryChange, closeGeneralMessageOptions, saveGeneralMessageOptions, onInputChange, newDescription, formatMessage }) {
  return generalMessageOptions && (
    <div className="message-box-content edit">
      <div className="wrapper">
        <span className="option-title">
          {formatMessage({ id: 'general.name' })}
        </span>

        <Input
          className="chat-name"
          value={newDescription}
          onChange={onInputChange}
          placeholder={chat.description || formatMessage({ id: 'chat.optional' })}
        />

        <span className="option-title">
        {formatMessage({ id: 'general.privacy' })}
      </span>

        <SelectCategories
          onCategoryChange={onCategoryChange}
          disabled
        />

        <span className="option-title">
        {formatMessage({ id: 'general.recipients' })}
      </span>

        <SelectReceivers
          recipients={chat.recipients}
          disabled
        />
      </div>

      <div className="message-configuration-buttons">
        <Button
          className="message-configuration cancel"
          onClick={closeGeneralMessageOptions}
        >
          {formatMessage({ id: 'general.cancel' })}
        </Button>

        <Button
          className="message-configuration apply"
          type="primary"
          onClick={saveGeneralMessageOptions}
          disabled={chat.description === newDescription}
        >
          {formatMessage({ id: 'general.apply' })}
        </Button>
      </div>
    </div>
  )
}

function GetNewChatComponents ({ newChat, onCategoryChange, chat, onSelectedUsersChange, onChatTitleChange, newChatDescription, draft, inputChatNamePlaceholder }) {
  if (!newChat) {
    return false
  }
  return (
    <div className="new-chat">
      <SelectCategories onCategoryChange={onCategoryChange} chat={chat} draft={draft}/>
      <SelectReceivers onSelectedUsersChange={onSelectedUsersChange} chat={chat} draft={draft}/>
      <Input
        className="chat-name"
        value={newChatDescription}
        onChange={onChatTitleChange}
        placeholder={inputChatNamePlaceholder}
      />
    </div>
  )
}

function GetMessageList ({ chat, loading, messages, handleInfiniteOnLoad, hasMorePages, newMessage, setNewMessagesToScrollCount, setMessageListRef, isLastMessageFromCurrentUser, loadingMore }) {
  return !chat.newChat && (
    <MessageList
      id={chat.id}
      loading={loading}
      list={messages}
      handleInfiniteOnLoad={handleInfiniteOnLoad}
      hasMorePages={hasMorePages}
      newMessage={newMessage}
      setNewMessagesToScrollCount={setNewMessagesToScrollCount}
      setMessageListRef={setMessageListRef}
      isLastMessageFromCurrentUser={isLastMessageFromCurrentUser}
      loadingMore={loadingMore}
    />
  )
}

function NewMessageSpanScroller ({ newMessagesToScrollCount, scrollMessageListToBottom, intl }) {
  return newMessagesToScrollCount > 0 && (
    <div
      className="new-message-anchor"
      onClick={scrollMessageListToBottom}
    >
      <span className="title">
        {intl.formatMessage({ id: 'chat.newMessagesReceived' },
          {
            number: newMessagesToScrollCount,
            messagePlural: newMessagesToScrollCount > 1 ? intl.formatMessage({ id: 'general.messagePlural' }) : intl.formatMessage({ id: 'general.messageSingular' })
          })}
      </span>

    </div>
  )
}

class MessageBoxContent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      newDescription: this.props.chat.description || '',
      newChatDescription: (this.props.draft && this.props.draft.title) || ''
    }
  }

  onInputChange (e) {
    const chatConfig = window.Social.getChatConfig()
    let title = e.target.value
    if (title.length >= chatConfig.descriptionMaxLength) {
      title = title.slice(0, chatConfig.descriptionMaxLength)
    }
    this.setState({
      newDescription: title
    })
  }

  saveGeneralMessageOptions () {
    this.props.saveGeneralMessageOptions({
      description: this.state.newDescription
    })
  }

  onChatTitleChange (e) {
    const chatConfig = window.Social.getChatConfig()
    let title = e.target.value
    if (title.length >= chatConfig.descriptionMaxLength) {
      title = title.slice(0, chatConfig.descriptionMaxLength)
    }
    this.setState({
      newChatDescription: title
    }, this.props.onChatTitleChange(e))
  }

  render () {
    const { formatMessage } = this.props.intl
    if (this.props.collapsed) {
      return false
    }

    if (this.props.generalMessageOptions) {
      return (
        <div className="message-box-content">
          <GeneralMessageOptions
            generalMessageOptions={this.props.generalMessageOptions}
            chat={this.props.chat}
            onCategoryChange={this.props.onCategoryChange}
            closeGeneralMessageOptions={this.props.closeGeneralMessageOptions}
            saveGeneralMessageOptions={this.saveGeneralMessageOptions.bind(this)}
            newDescription={this.state.newDescription}
            formatMessage={formatMessage}
            onInputChange={this.onInputChange.bind(this)}
          />
        </div>
      )
    }

    return (
      <div className={`message-box-content ${this.props.chat.newChat ? 'new-chat' : 'chat'}`}>
        <GetNewChatComponents
          newChat={this.props.chat.newChat}
          onCategoryChange={this.props.onCategoryChange}
          onSelectedUsersChange={this.props.onSelectedUsersChange}
          chat={this.props.chat}
          draft={this.props.draft}
          onChatTitleChange={this.onChatTitleChange.bind(this)}
          newChatDescription={this.state.newChatDescription}
          inputChatNamePlaceholder={this.props.intl.messages['chat.optionalTitle']}
        />

        <GetMessageList
          chat={this.props.chat}
          loading={this.props.loading}
          messages={this.props.messages}
          handleInfiniteOnLoad={this.props.handleInfiniteOnLoad}
          hasMorePages={this.props.hasMorePages}
          newMessage={this.props.newMessage}
          setNewMessagesToScrollCount={this.props.setNewMessagesToScrollCount}
          setMessageListRef={this.props.setMessageListRef}
          isLastMessageFromCurrentUser={this.props.isLastMessageFromCurrentUser}
          loadingMore={this.props.loadingMore}
        />

        <MessageInput
          chat={this.props.chat}
          readOnly={this.props.waitingMessageSentConfirmation}
          chatState={this.props.chatState}
          initialState={this.props.draft && this.props.draft.message}
          newChat={this.props.chat.newChat}
          canSendMessage={this.props.canSendMessage}
          waitingMessageSentConfirmation={this.props.waitingMessageSentConfirmation}
          sendMessage={this.props.sendMessage}
          onFocus={() => this.props.dismissNotification(this.props.chat.id)}
          onChange={this.props.onMessageInputChange}
          onFlagSelect={this.props.onFlagSelect}
          flags={this.props.flags}
          profiles={this.props.profiles}
        />

        <NewMessageSpanScroller
          newMessagesToScrollCount={this.props.newMessagesToScrollCount}
          scrollMessageListToBottom={this.props.scrollMessageListToBottom}
          intl={this.props.intl}
        />
      </div>
    )
  }
}

export default (injectIntl(MessageBoxContent))
